import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {IonicStorageModule} from '@ionic/storage';


import {IonicModule} from '@ionic/angular';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';

import {ComponentsModule} from './components/components.module';
import {ReactiveFormsModule} from '@angular/forms';

import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {SuperTabsModule} from '@ionic-super-tabs/angular';
import {SocialSharing} from '@ionic-native/social-sharing/ngx';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import {Camera} from '@ionic-native/camera/ngx';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {AngularFireModule} from '@angular/fire';
import {environment} from '../environments/environment';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {CalendarLogPageModule} from './calendar-log/calendar-log.module';
import {AngularFirestoreModule} from '@angular/fire/firestore';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
const config = {
  apiKey: "AIzaSyCj3MSy-FMPWfLMC_7oSvudVyLQHPsjrqY",
  authDomain: "my-pt-zim-fb13e.firebaseapp.com",
  databaseURL: "https://my-pt-zim-fb13e.firebaseio.com",
  projectId: "my-pt-zim-fb13e",
  storageBucket: "my-pt-zim-fb13e.appspot.com",
  messagingSenderId: "345553986025",
  appId: "1:345553986025:web:2a1de8c1c6e15d978dab78"
};

@NgModule({
  declarations: [AppComponent,
//  SettingsPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot ( {
      mode: 'ios'
    }),
    ReactiveFormsModule,
    AppRoutingModule,


    ComponentsModule,
    SuperTabsModule.forRoot(),
      AngularFireDatabaseModule,
    AngularFireModule.initializeApp(environment.firebase),
      AngularFireStorageModule,
      AngularFireAuthModule,
    CalendarLogPageModule,
      AngularFirestoreModule.enablePersistence(),


    IonicStorageModule.forRoot(
        {
          name: '__ptzim',
          driverOrder: [ 'sqlite', 'indexeddb', 'websql']
        }
    ),


    //ServiceWorkerModule.register('/ngsw-worker.js', { enabled: environment.production }),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    })
  ],
  entryComponents:[
     // SettingsPage

  ]
  ,
  providers: [
      SplashScreen,
      StatusBar,
      SocialSharing,
      Camera,

  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
